module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_7_2.af447d75.png";